// src/pages/LoginErrorPage.tsx
import React from 'react';

const LoginErrorPage: React.FC = () => (
  <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-header)', minHeight: '60vh', }}>
    <h1>Login Temporarily Disabled</h1>
    <p>Too many failed login attempts.</p>
    <p>Please wait a few minutes and try again.</p>
  </div>
);

export default LoginErrorPage;